import { ComponentProps, ReactNode, useId } from 'react';

import { InputLabel } from '@/components/InputLabel';
import { inputVariants } from '@/components/ui/input';
import { Textarea as TextareaUI } from '@/components/ui/textarea';

import { cn } from '@/lib/utils';

type TextareaProps = ComponentProps<'textarea'> & {
  label?: ReactNode;
  hint?: ReactNode;
  isRequired?: boolean;
};

const Textarea = (props: TextareaProps) => {
  const {
    className,
    label,
    hint,
    isRequired,
    id,
    'aria-invalid': ariaInvalid,
    ...restProps
  } = props;

  const generatedId = useId();
  const textareaId = id ?? generatedId;

  return (
    <div className="flex flex-col gap-2">
      {label && (
        <InputLabel
          htmlFor={textareaId}
          label={label}
          hint={hint}
          isRequired={isRequired}
          isInvalid={Boolean(ariaInvalid)}
        />
      )}
      <TextareaUI
        id={textareaId}
        className={cn(inputVariants({ height: 'auto' }), 'py-3', className)}
        aria-invalid={ariaInvalid}
        {...restProps}
      />
    </div>
  );
};

export { Textarea };
export type { TextareaProps };
